<template>
  <div class="main">
    <!-- <TabMenu :menuIndex="menuIndex" :menu="menu" /> -->

    <!-- <Tab class="tab" ref="Tab" :tabIdx="tabIdx" :data="tabData" @onToggleTab="onToggleTab" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">

      <template slot="detail" slot-scope="scope">
        <div class="detail" @click="goDetail(scope.params.id)">
          点此维护
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      tabIdx: 0,
      tabData: [
        {
          name: "在用",
        },
        {
          name: "停用",
        },
      ],
      menuIndex: `/customer/manage/table/1`,
      menu: [
        {
          name: "在用",
          path: `/customer/manage/table/1`,
        },
        {
          name: "停用",
          path: `/customer/manage/table/2`,
        },
      ],
      baseUrl: 'custom',
      formInline: {
        customstatus: '在用',
      },
      baseParams: ['customstatus'],
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "公司名称",
          keyName: "pname",
          placeholder: "请填写公司名称",
          type: "text",
        },
        {
          label: "联系人",
          keyName: "member",
          placeholder: "请填写联系人",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "公司名称" },
        { keyName: "member", label: "联系人" },
        { keyName: "phone", label: "联系电话" },
        { keyName: "address", label: "公司地址" },
        { keyName: "industry", label: "所属行业" },
        { keyName: "product", label: "主营业务" },
        { keyName: "fleetname", label: "所属车队长" },
        { keyName: "addname", label: "添加人" },
        { keyName: "detail", label: "维护记录", slot: 'detail' },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/customer/detail?id=${id}&mode=edit`
            );
          },
        },
        {
          class: 'routebtn',
          title: '路线管理',
          img: require('@/assets/img/icon-route.png'),
          unimg: require('@/assets/img/icon-route-hover.png'),
          cb: ({ id }) => {
            this.$router.push(`/customer/route?custom_id=${id}`)
          },
        },
        {
          class: 'kaibtn',
          title: '开票信息',
          img: require('@/assets/img/kai.png'),
          unimg: require('@/assets/img/kai1.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/customer/kai?id=${id}&mode=kai`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      console.log(this.$route.params)
      this.getParams()
    },
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    getParams() {
      const { idx } = this.$route.params

      this.formInline.customstatus = idx == 1 ? '在用' : '停用'

      this.getList()
    },
    goDetail(id) {
      this.$router.push(
        `/customer/view?id=${id}&mode=edit`
      );
    },
    add() {
      this.$router.push(
        `/customer/detail?mode=add`
      );
    },
    onToggleTab({ index }) {
      // this.tabIdx = index;
      console.log(index)
      if (index == 1) {
        this.$set(this.formInline, 'customstatus', '停用')
      } else {
        this.$set(this.formInline, 'customstatus', '在用')
      }
      this.getList()
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
      // this.getList()
    }
  },
  mounted() {
    this.getFleet();
    this.getList()
  },
};
</script>

<style lang="less" scoped>
/deep/.detail {
  font-size: 14px;
  font-weight: 400;
  color: #2691FF;
  cursor: pointer;
}

.main .tab {
  /deep/ .el-tabs__header {
    padding: 0;

    .el-tabs__nav {
      .el-tabs__active-bar {
        height: 0;
      }

      .el-tabs__item {
        width: auto;
        height: 40px;
        line-height: 40px;
        margin: 0 10px;
        padding: 0 20px;
        transition: border-color .3s, background-color .3s, color .3s;

        &.is-active {
          border-bottom: 3px solid #2691FF;
          box-sizing: border-box;
          transition: border-color .3s, background-color .3s, color .3s;
        }
      }
    }
  }
}
</style>